module.exports = __webpack_public_path__ + "img/circle-n.437ab1f9.svg";